
import { useState } from 'react';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import axios from '../../axios';
import { useNavigate } from 'react-router-dom';
import usePermisos from '../../hooks/usePermisos';
import NoPermissions from '../NoPermissions/NoPermissions';


const PERMISOS_REQUERIDOS = ['sucursals_create'];

const New = () => {
    const [sucursal, setSucursal] = useState({
        nombre_sucursal: '',
        domicilio: '',
        horario: '',
        horario_entregas: '',
        telefono1: '',
        telefono2: '',
        telefono3: '',
        hora_cierre_manana: '14:00',
        hora_cierre_tarde: '19:00'
    });
    const [validate, setValidate] = useState({
        nombre_sucursal: true,
        domicilio: true,
        horario: true,
        horario_entregas: true,
        telefono1: true,
        tolerancia_minutos: true,
        hora_cierre_manana: true,
        hora_cierre_tarde: true,
    });
    const navigate = useNavigate();
    const { permisos, loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);

    const _saveSucursal = (e) => {
        e.preventDefault();
        axios.post('api/sucursals', sucursal)
            .then(res => {
                alert('Sucursal creada exitosamente');
                setTimeout(() => {
                    navigate('/admin/sucursales');
                }, 1000);
            })
            .catch(e => {
                if (e.response && e.response.data && e.response.data.errors) {
                    let errors = e.response.data.errors;
                    setValidate({
                        nombre_sucursal: !errors.nombre_sucursal,
                        domicilio: !errors.domicilio,
                        horario: !errors.horario,
                        horario_entregas: !errors.horario_entregas,
                        telefono1: !errors.telefono1,
                        telefono2: !errors.telefono2,
                        telefono3: !errors.telefono3,
                        tolerancia_minutos: !errors.tolerancia_minutos,
                        hora_cierre_manana: !errors.hora_cierre_manana,
                        hora_cierre_tarde: !errors.hora_cierre_tarde,
                    });
                }
            });
    };

    if (loadingPermisos) {
        return <div className="p-5 text-center">Cargando...</div>;
    }
    if (!tienePermiso('sucursals_create')) {
        return <NoPermissions />;
    }

    return (
        <div>
            <div className="container-admin-menu">
                <Breadcrumb />
            </div>
            <div className="container-admin-container">
                <div className="container-admin bg-white rounded-lg shadow-md">
                    <h5 className="p-5 text-xl font-bold flex items-center justify-start">Nueva Sucursal</h5>
                    <div className="col-span-12">
                        <span className="text-sm text-orange-500">*Para Horario Corrido seleccionar la misma hora de cierre en la mañana y en la tarde.</span>
                    </div>
                    <form onSubmit={_saveSucursal} className="grid grid-cols-12 gap-4 px-5 pb-5" id="general-form">
                        {/* Nombre */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="nombre_sucursal" className="text-sm font-medium text-gray-600">Nombre de la sucursal *</label>
                                <input
                                    id="nombre_sucursal"
                                    type="text"
                                    className="dento-input"
                                    value={sucursal.nombre_sucursal}
                                    onChange={e => setSucursal({ ...sucursal, nombre_sucursal: e.target.value })}
                                />
                                {!validate.nombre_sucursal && (
                                    <span className="text-sm text-red-500">El nombre es obligatorio.</span>
                                )}
                            </div>
                        </div>
                        {/* Domicilio */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="domicilio" className="text-sm font-medium text-gray-600">Domicilio *</label>
                                <textarea
                                    id="domicilio"
                                    className="dento-input min-h-26"
                                    value={sucursal.domicilio}
                                    onChange={e => setSucursal({ ...sucursal, domicilio: e.target.value })}
                                />
                                {!validate.domicilio && (
                                    <span className="text-sm text-red-500">El domicilio es obligatorio.</span>
                                )}
                            </div>
                        </div>
                        {/* Horario de atención */}
                        <div className="col-span-12 md:col-span-4">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="horario" className="text-sm font-medium text-gray-600">Horario de Atención *</label>
                                <input
                                    id="horario"
                                    type="text"
                                    className="dento-input"
                                    value={sucursal.horario}
                                    onChange={e => setSucursal({ ...sucursal, horario: e.target.value })}
                                />
                                {!validate.horario && (
                                    <span className="text-sm text-red-500">El horario de atención es obligatorio.</span>
                                )}
                            </div>
                        </div>
                        {/* Horario de entrega */}
                        <div className="col-span-12 md:col-span-4">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="horario_entregas" className="text-sm font-medium text-gray-600">Horario de Entrega *</label>
                                <input
                                    id="horario_entregas"
                                    type="text"
                                    className="dento-input"
                                    value={sucursal.horario_entregas}
                                    onChange={e => setSucursal({ ...sucursal, horario_entregas: e.target.value })}
                                />
                                {!validate.horario_entregas && (
                                    <span className="text-sm text-red-500">El horario de entrega es obligatorio.</span>
                                )}
                            </div>
                        </div>
                        {/* Tolerancia en minutos */}
                        <div className="col-span-12 md:col-span-4">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="tolerancia_minutos" className="text-sm font-medium text-gray-600">Tolerancia en Minutos *</label>
                                <input
                                    id="tolerancia_minutos"
                                    type="number"
                                    className="dento-input"
                                    value={sucursal.tolerancia_minutos || ''}
                                    onChange={e => setSucursal({ ...sucursal, tolerancia_minutos: e.target.value })}
                                />
                                {!validate.tolerancia_minutos && (
                                    <span className="text-sm text-red-500">La tolerancia en minutos es obligatoria y debe ser un número.</span>
                                )}
                            </div>
                        </div>
                        {/* Hora de cierre mañana */}
                        <div className="col-span-12 md:col-span-4">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="hora_cierre_manana" className="text-sm font-medium text-gray-600">Hora Cierre Mañana *</label>
                                <input
                                    id="hora_cierre_manana"
                                    type="time"
                                    className="dento-input"
                                    value={sucursal.hora_cierre_manana || ''}
                                    onChange={e => setSucursal({ ...sucursal, hora_cierre_manana: e.target.value })}
                                />
                                {!validate.hora_cierre_manana && (
                                    <span className="text-sm text-red-500">La hora de cierre de la mañana es obligatoria.</span>
                                )}
                                <span className="text-xs text-gray-500">Para horario corrido, usar la misma hora que el turno tarde</span>
                            </div>
                        </div>
                        {/* Hora de cierre tarde */}
                        <div className="col-span-12 md:col-span-4">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="hora_cierre_tarde" className="text-sm font-medium text-gray-600">Hora Cierre Tarde *</label>
                                <input
                                    id="hora_cierre_tarde"
                                    type="time"
                                    className="dento-input"
                                    value={sucursal.hora_cierre_tarde || ''}
                                    onChange={e => setSucursal({ ...sucursal, hora_cierre_tarde: e.target.value })}
                                />
                                {!validate.hora_cierre_tarde && (
                                    <span className="text-sm text-red-500">La hora de cierre de la tarde es obligatoria.</span>
                                )}
                                <span className="text-xs text-gray-500">Hora de cierre del último turno del día</span>
                            </div>
                        </div>
                        {/* Teléfonos */}
                        <div className="col-span-12 md:col-span-4">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="telefono1" className="text-sm font-medium text-gray-600">Teléfono *</label>
                                <input
                                    id="telefono1"
                                    type="number"
                                    className="dento-input"
                                    value={sucursal.telefono1}
                                    onChange={e => setSucursal({ ...sucursal, telefono1: e.target.value })}
                                />
                                {!validate.telefono1 && (
                                    <span className="text-sm text-red-500">El teléfono es obligatorio y de 10 dígitos.</span>
                                )}
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-4">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="telefono2" className="text-sm font-medium text-gray-600">Teléfono 2</label>
                                <input
                                    id="telefono2"
                                    type="number"
                                    className="dento-input"
                                    value={sucursal.telefono2}
                                    onChange={e => setSucursal({ ...sucursal, telefono2: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-4">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="telefono3" className="text-sm font-medium text-gray-600">Teléfono 3</label>
                                <input
                                    id="telefono3"
                                    type="number"
                                    className="dento-input"
                                    value={sucursal.telefono3}
                                    onChange={e => setSucursal({ ...sucursal, telefono3: e.target.value })}
                                />
                            </div>
                        </div>
                        {/* Botón guardar */}
                        <div className="col-span-12 pt-6 flex justify-end">
                            <button
                                className="inline-flex items-center gap-2 px-6 py-2.5 bg-blue-600 text-white hover:bg-blue-700 font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                type="submit"
                            >
                                Guardar
                                <span className="material-icons">send</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default New;